import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import styles from './style.module.scss';

const TRANSLATION_KEY_TYPE_COMPONENT = 'Heading.string';
const TRANSLATION_KEY_TYPE = 'Heading2.string';

export function Heading(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const TEXT = t(TRANSLATION_KEY_TYPE_COMPONENT, { type: t(props.typeString), component: t(props.componentString), interpolation: { escapeValue: false } });
  const TEXT_WITHOUT_COMPONENT = t(TRANSLATION_KEY_TYPE, { type: t(props.typeString), interpolation: { escapeValue: false } });
  return <h1 className={styles.move_menu_heading}>{
    (
      props.component === "gel" ||
      props.component === "power supply lead" ||
      props.component === "floating tube rack" ||
      props.component === "cell spreader" ||
      props.component === "lab tape" ||
      props.component === "box" ||
      props.component === "plant" ||
      props.component === "stopper" ||
      props.component === "cuvette" ||
      props.component === "cuvette lid" ||
      props.component === "waste collection jar"
    )?
      TEXT_WITHOUT_COMPONENT
    :
      TEXT
    }</h1>;
}

Heading.propTypes = {};
Heading.defaultProp = {};
